import { GetSystemKeysCondition } from '@/api'

export interface GetSystemParameterKeysRequest {
  codeKey: string
  searchKey: string
  condition: GetSystemKeysCondition
}

export function GetSystemParameterKeysRequestToJSON(
  value: GetSystemParameterKeysRequest
): any {
  return {
    code_key: value.codeKey !== '' ? value.codeKey : undefined,
    search_key: value.searchKey !== '' ? value.searchKey : '', // このプロパティだけはヴァリデーションを動作させるために常にリクエストに渡す
    condition: value.condition ? value.condition : undefined
  }
}
